<div class="form-row row">
  <app-field-assignment-grid [isColumnBased]="false"></app-field-assignment-grid>
</div>
